(function (angular, app) {
    'use strict';

    app.service('ChooseAreaDialog', [
        '$rootScope', '$state', '$injector', '$q', '$timeout', '$location', 'Config', 'mDesign', 'ExternalCheckout', 'DeliveryWithinDaysWarningDialog',
        function($rootScope, $state, $injector, $q, $timeout, $location, Config, mDesign, ExternalCheckout, DeliveryWithinDaysWarningDialog) {
            var self = this,
                Cart,
                waitPromise,
                Config;

            self.show = show;
            self.isPresent = false;
            
            function show(allowClosing, doNotAllowChooseRetailers, areaName, openPickup, area, addressDetails) {
                Cart = Cart || $injector.get('Cart');
                Config = $injector.get('Config');

                var queryAreaName = null;
                var search = $location.search();

                if (search.hubChildrenSearchText) {
                    queryAreaName = search.hubChildrenSearchText;
                    $location.search('hubChildrenSearchText', null);
                }

                //== when cart is in Update Mode - branch switching is disabled - show popup
                if (Cart.editOrderId) {
                    return mDesign.alert('You in the middle of editing order. Changing store is impossible').then(function(){
                        throw 'Cannot change area when editing order';
                    });
                }
                if ($rootScope.bodyClass.currentPage === 'shipmentTracking') {
                    return;
                }
                // prevent double show
                if(self.isPresent){
                    return;
                }
                self.isPresent = true;

                var dialogTemplateUrl = Config.advancedAreaAvailabilityEnabled ? 'views/choose-area-advanced/main.html' : 'views/templates/choose-area.html';

                return _waitBeforeAreaDialog().then(function() {
                    return mDesign.dialog({
                        controller: 'ChooseAreaCtrl as chooseAreaCtrl',
                        templateUrl: dialogTemplateUrl,
                        clickOutsideToClose: allowClosing,
                        escapeToClose: false,
                        multiple: false,
                        locals: {
                            doNotAllowChooseRetailers: doNotAllowChooseRetailers,
                            areaName: areaName,
                            queryAreaName: queryAreaName,
                            openPickup: openPickup,
                            allowClosing: allowClosing,
                            area: area,
                            addressDetails: addressDetails,
                        }
                    });
                }).then(function(response) {
                    Cart.validateDeliveryItemsLimit();
                    DeliveryWithinDaysWarningDialog.show();
                    self.isPresent = false;
                    return response;
                }, function(err){
                    self.isPresent = false;
                });
            }

            function _waitBeforeAreaDialog() {
                return _canShowDialog().then(function(can) {
                    if (can || waitPromise) {
                        return waitPromise;
                    }

                    return waitPromise = new $q(function(resolve) {
                        var listener = $rootScope.$on('$stateChangeSuccess', function() {
                            _canShowDialog().then(function(can) {
                                if (can) {
                                    listener();
                                    resolve();
                                }
                            });
                        });
                    }).then(function() {
                        // wait to allow state change to complete the url change
                        return $timeout(angular.noop, 1000);
                    }).then(function () {
                        waitPromise = null;
                    });
                });
            }

            function _canShowDialog() {
                return $q.all([
                    ExternalCheckout.isInExternalCheckoutFinishPage(true),
                    $state.includes('app.user-confirmation')
                ]).then(function(results) {
                    return !results.find(function(value) {
                        return value;
                    });
                });
            }
        }
    ]);

    app.run(['$rootScope', 'ChooseAreaDialog', function($rootScope, ChooseAreaDialog) {
        $rootScope.ChooseAreaDialog = ChooseAreaDialog;
    }]);

    var CHOOSE_AREA_STATES = {
        TYPE_AREA: 1,
        CHOOSE_AREA: 2,
        AREA_NOT_FOUND: 3
    };

    app.controller('ChooseAreaCtrl', [
        '$state', '$location', '$rootScope', '$timeout', 'Config', 'Util', 'User', 'Loading', 'mDesign', 'SpDeliveryAreasService',
        'SpProductTags', 'doNotAllowChooseRetailers', 'areaName', 'queryAreaName', 'openPickup', 'allowClosing', 'area', 'addressDetails', 'SP_SERVICES',
        'DELIVERY_TIMES_TYPES', 'DELIVERY_MODE_TOGGLE', 'PermanentFilters','PRODUCT_TAG_ID', 'Cart',
        function ($state, $location, $rootScope, $timeout, Config, Util, User, Loading, mDesign, SpDeliveryAreasService,
            SpProductTags, doNotAllowChooseRetailers, areaName, queryAreaName, openPickup, allowClosing, area, addressDetails, SP_SERVICES,
            DELIVERY_TIMES_TYPES, DELIVERY_MODE_TOGGLE, PermanentFilters,PRODUCT_TAG_ID, Cart) {
            var chooseAreaCtrl = this,
                searchParams = $location.search(),
                $dialogElement;

            chooseAreaCtrl.CHOOSE_AREA_STATES = CHOOSE_AREA_STATES;
            chooseAreaCtrl.addressDetails = angular.copy(addressDetails, {});
            chooseAreaCtrl.showTypeAreaState = showTypeAreaState;
            chooseAreaCtrl.autoCompleteAreas = autoCompleteAreas;
            chooseAreaCtrl.searchTypedArea = searchTypedArea;
            chooseAreaCtrl.resetErrors = resetErrors;
            chooseAreaCtrl.filterAreasInputChange = filterAreasInputChange;
            chooseAreaCtrl.showPickupAreas = showPickupAreas;
            chooseAreaCtrl.chooseArea = chooseArea;
            chooseAreaCtrl.handleExpressDeliverySelection = handleExpressDeliverySelection;
            chooseAreaCtrl.filterFoundAreas = filterFoundAreas;
            chooseAreaCtrl.getBranchLocation = SpDeliveryAreasService.getAreaAddressText;
            chooseAreaCtrl.areaNotFoundLog = areaNotFoundLog;
            chooseAreaCtrl.cancel = cancel;
            chooseAreaCtrl.allowClosing = allowClosing;
            chooseAreaCtrl.isShowDeliveryWithinDaysWarning = isShowDeliveryWithinDaysWarning;
            chooseAreaCtrl.changeVisibleState = changeVisibleState;
            chooseAreaCtrl.selectTab = selectTab;
            chooseAreaCtrl.addStyle = addStyle;
            chooseAreaCtrl.chooseAreaText = (Config.retailer.chooseAreaText || []).find(function(text) {
                return text.languageId === Config.language.id
            });
            chooseAreaCtrl.isBranchNameHidden = isBranchNameHidden;
            chooseAreaCtrl.isPresent = false;
            chooseAreaCtrl.getDeliveryInputPlaceholder = getDeliveryInputPlaceholder;
            chooseAreaCtrl.goToFilterAreas = goToFilterAreas;
            chooseAreaCtrl.mobileExpressDeliverySettings = {};
            chooseAreaCtrl.shouldShowExpressDelivery = shouldShowExpressDelivery;
            chooseAreaCtrl.getScheduledDeliveryButtonText = getScheduledDeliveryButtonText;
            chooseAreaCtrl.isActiveMobileExpress = false;

            var chooseAreaAdvancedDialogs = {
                PICKUP_AND_DELIVERY: 'views/choose-area-advanced/pickup-and-delivery.html',
                NO_PICKUP: 'views/choose-area-advanced/no-pickup.html',
                NO_STORE_FOUND: 'views/choose-area-advanced/delivery-result/no-store-found.html',
                ONE_STORE_FOUND: 'views/choose-area-advanced/delivery-result/one-store-found.html',
                MULTIPLE_STORE_FOUND: 'views/choose-area-advanced/delivery-result/multiple-store-found.html',
                CHOOSE_PICKUP_TAB: 'views/choose-area-advanced/choose-pickup-tab.html',
                CHOOSE_DELIVERY_TAB: 'views/choose-area-advanced/choose-delivery-tab.html'
            };

            var chooseAreaAdvancedExpressDeliveryDialogs = {
                NO_STORE_FOUND: 'views/choose-area-advanced/express-delivery-result/no-store-found.html',
                ONE_STORE_FOUND: 'views/choose-area-advanced/express-delivery-result/one-store-found.html',
                MULTIPLE_STORE_FOUND: 'views/choose-area-advanced/express-delivery-result/multiple-store-found.html',
            };
            
            Config.waitForInit().then(function () {
                if (Config.retailer.settings) {
                    chooseAreaCtrl.isActiveMobileExpress = Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) && Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery).isActive || false;
                    chooseAreaCtrl.mobileExpressDeliverySettings = Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) || {};
                    
                    // if mobile express delivery is active, use express delivery dialogs
                    if (chooseAreaCtrl.isActiveMobileExpress) {
                        angular.extend(chooseAreaAdvancedDialogs, chooseAreaAdvancedExpressDeliveryDialogs);
                    }
                }
            });
           
            var searchMessageModes = {
                NO_STORE_FOUND: {
                    id: 0,
                    name: 'No Stores Found',
                    property: 'noStore',
                    defaultPopupTitle: 'default_no_store_popup_title',
                    defaultPopupSubTitle: 'default_no_store_popup_sub_title'
                },
                ONE_STORE_FOUND: {
                    id: 1,
                    name: 'One Store Found',
                    property: 'oneStore',
                    defaultPopupTitle: 'default_one_store_popup_title',
                    defaultPopupSubTitle: 'default_one_store_popup_sub_title',
                    defaultContinueButtonText: 'default_one_store_popup_continue_button_text'
                },
                MULTIPLE_STORE_FOUND: {
                    id: 2,
                    name: 'Multiple Stores Found',
                    property: 'multipleStore',
                    defaultPopupTitle: 'default_multiple_store_popup_title',
                    defaultPopupSubTitle: 'default_multiple_store_popup_sub_title'
                }
            };

            _init();
            SpDeliveryAreasService.setPreferredRetailerId(searchParams.retailerId && Number(searchParams.retailerId) || undefined);

            function _init() {
                if ($rootScope.disablePopupOnCurrentRoute) {
                    $rootScope.disablePopupOnCurrentRoute = false;
                    return selectArea(area);
                }

                return Config.waitForInit().then(function() {
                    return SpDeliveryAreasService.getChooseAreaMode(!doNotAllowChooseRetailers);
                }).then(function(mode) {
                    chooseAreaCtrl.isChangeArea = !!Config.branchAreaName;
                    chooseAreaCtrl.chooseAreaMode = mode;

                    if (Config.advancedAreaAvailabilityEnabled && Config.advancedAreaAvailabilitySettings) {
                        _initAdvancedAreaAvailability();

                        addStyle();
                    }

                    if (mode === SP_SERVICES.CHOOSE_AREA_MODE.CHOOSE_RETAILER) {
                        chooseAreaCtrl.firstState = chooseAreaCtrl.visibleState = CHOOSE_AREA_STATES.CHOOSE_AREA;
                        SpDeliveryAreasService.getAreas().then(function (areas) {
                            _setFoundAreas(areas);
                        });
                    } else {
                        SpDeliveryAreasService.getPickupAreas().then(function (pickupAreas) {
                            chooseAreaCtrl.pickupAreas = pickupAreas;

                            if (openPickup || Config.advancedAreaAvailabilityEnabled) {
                                showPickupAreas();
                            }
                        });

                        chooseAreaCtrl.firstState = CHOOSE_AREA_STATES.TYPE_AREA;
                        showTypeAreaState();

                        if (queryAreaName) {
                            chooseAreaCtrl.queryArea = queryAreaName;
                            searchTypedArea(true);
                            return;
                        }

                        // In case areaName is sent in locals use it immediately
                        if (areaName) {
                            chooseAreaCtrl.area = areaName;
                            searchTypedArea(true);
                            return;
                        }

                        // In case NO areaName but we want find area by lat & lng
                        if(chooseAreaCtrl.addressDetails.geoCoordinates) {
                            searchTypedArea(true);
                            return;
                        }
                    }

                });
            }

            function _setAreaAdvancedTemplate(){
                chooseAreaCtrl.chooseAreaAdvancedTemplate = chooseAreaAdvancedDialogs.PICKUP_AND_DELIVERY;
                chooseAreaCtrl.defaultTabId =  chooseAreaCtrl.currentAdvancedAreaAvailabilitySettings.firstDefaultTab ? 1 : 0;
        
                var retailerSupportedDeliveryMethod = Util.getRetailerSupportedDeliveryMethod();
                if (!retailerSupportedDeliveryMethod.isPickupSupported) {
                    chooseAreaCtrl.defaultTabId = 0;
                    chooseAreaCtrl.chooseAreaAdvancedTemplate = chooseAreaAdvancedDialogs.NO_PICKUP;
                }
            }

             // start advanced area availability setting
            function _initAdvancedAreaAvailability() {
                var scenarioId = localStorage.mobileZuzIsAreaChosen === 'true' ? 1 : 0;  // 0= first time, 1=returning
                chooseAreaCtrl.searchMessageMode = -1;
                chooseAreaCtrl.language = Config.language;
                chooseAreaCtrl.advancedAreaAvailabilitySettings = Config.advancedAreaAvailabilitySettings;
                chooseAreaCtrl.currentAdvancedAreaAvailabilitySettings = Config.advancedAreaAvailabilitySettings[Config.language.id];
                
                
                _setAreaAdvancedTemplate();
                chooseAreaCtrl.chooseAreaAdvancedCurrentDialog = chooseAreaCtrl.chooseAreaAdvancedTemplate;
                
                chooseAreaCtrl.tabs = {
                    PICKUP: {
                        id: 1,
                        title: chooseAreaCtrl.advancedAreaAvailabilitySettings[Config.language.id].pickupTabName,
                        templateUrl: chooseAreaAdvancedDialogs.CHOOSE_PICKUP_TAB,
                        controller: "ChooseAreaCtrl as chooseAreaCtrl",
                    },
                    DELIVERY: {
                        id: 0,
                        title: chooseAreaCtrl.advancedAreaAvailabilitySettings[Config.language.id].deliveryTabName,
                        templateUrl: chooseAreaAdvancedDialogs.CHOOSE_DELIVERY_TAB,
                        controller: "ChooseAreaCtrl as chooseAreaCtrl",
                    }
                };
                selectTab(chooseAreaCtrl.defaultTabId);

                var scenarios = [
                    {
                        id: 0,
                        name: 'First-Time Visitor (No address or store selected)',
                        property: 'firstTime',
                        defaultPopupTitle: 'default_first_time_popup_title',
                        defaultPopupSubTitle: 'default_first_time_popup_sub_title',
                        defaultPopupSubTitlePickup: 'default_first_time_popup_sub_title_pickup',
                        defaultPopupSubTitleDelivery: 'default_first_time_popup_sub_title_delivery',
                    },
                    {
                        id: 1,
                        name: 'Returning Visitor (Switching store selection)',
                        property: 'returning',
                        defaultPopupTitle: 'default_returning_popup_title',
                        defaultPopupSubTitle: 'default_returning_popup_sub_title',
                        defaultPopupSubTitlePickup: 'default_returning_popup_sub_title_pickup',
                        defaultPopupSubTitleDelivery: 'default_returning_popup_sub_title_delivery',
                    }
                ];
                chooseAreaCtrl.currentScenario = scenarios[scenarioId];

                chooseAreaCtrl.currentSearchMessageMode = null;
                chooseAreaCtrl.defaultStoreIcon = 'https://d226b0iufwcjmj.cloudfront.net/global/advanced-area-availability/default-store-icon.svg';
                chooseAreaCtrl.defaultDeliveryImage = 'https://d226b0iufwcjmj.cloudfront.net/global/advanced-area-availability/default-delivery-image.png';
                chooseAreaCtrl.defaultResultsImage = 'https://d226b0iufwcjmj.cloudfront.net/global/advanced-area-availability/default-delivery-result-image.png';

            }

            function addStyle() {
                var defaultMainColor = (window.tempConfig && window.tempConfig.color) || '#207d3f';
                var defaultTextColor = '#ffffff';
                chooseAreaCtrl.textColor = Config.advancedAreaAvailabilitySettings[Config.language.id].tabsAndButtonsTextColor || defaultTextColor;
                chooseAreaCtrl.bgColor = Config.advancedAreaAvailabilitySettings[Config.language.id].tabsAndButtonsBgColor || defaultMainColor;
            }

            function getDeliveryInputPlaceholder() {
                if (chooseAreaCtrl.chooseAreaText && !!chooseAreaCtrl.chooseAreaText.placeholder.length) {
                    return chooseAreaCtrl.chooseAreaText.placeholder;
                }

                if (chooseAreaCtrl.chooseAreaMode === $rootScope.SP_SERVICES.CHOOSE_AREA_MODE.TYPE_GOOGLE_ADDRESS) {
                    return 'delivery_input_address_placeholder';
                }

                if ($rootScope.config.isZipCodeArea) {
                    return 'delivery_input_zip_code_placeholder'
                }

                return 'Please enter a city';
            }
             // end advanced area availability setting

            function goToFilterAreas() {
                chooseAreaCtrl.visibleState = chooseAreaCtrl.filterAreas;
                chooseAreaCtrl.currentSearchMessageMode = null;
                chooseAreaCtrl.chooseAreaAdvancedCurrentDialog = chooseAreaCtrl.chooseAreaAdvancedTemplate;
                selectTab(chooseAreaCtrl.currentTab.id);
            }

            function selectTab(tabId) {

                if (tabId === chooseAreaCtrl.tabs.DELIVERY.id) {
                    chooseAreaCtrl.currentTab = chooseAreaCtrl.tabs.DELIVERY;
                    return chooseAreaCtrl.changeVisibleState(chooseAreaCtrl.CHOOSE_AREA_STATES.TYPE_AREA);
                }

                if(tabId === chooseAreaCtrl.tabs.PICKUP.id) {
                    chooseAreaCtrl.currentTab = chooseAreaCtrl.tabs.PICKUP;
                    chooseAreaCtrl.showPickupAreas();
                    return chooseAreaCtrl.changeVisibleState(chooseAreaCtrl.CHOOSE_AREA_STATES.CHOOSE_AREA);
                }
            }

            function showTypeAreaState() {
                changeVisibleState(CHOOSE_AREA_STATES.TYPE_AREA);
            }

            function autoCompleteAreas() {
                if (chooseAreaCtrl.addressChoices){
                    return chooseAreaCtrl.filterAreas.addressChoices;
                }
                else{
                    return SpDeliveryAreasService.autoCompleteDeliveryAreasWithFullData(chooseAreaCtrl.chooseAreaMode, chooseAreaCtrl.area).then(function(response){
                        chooseAreaCtrl.fullAutoCompleteData = response.places;
                        return response.names;
                    })
                }
            }

            function searchTypedArea(ignoreMultipleAddresses) {
                delete chooseAreaCtrl.addressChoices;

                var options = {
                    placeId: chooseAreaCtrl.addressDetails.placeId,
                    geoCoordinates: chooseAreaCtrl.addressDetails.geoCoordinates,
                }

                if (!chooseAreaCtrl.area && !chooseAreaCtrl.queryArea && !options.geoCoordinates) {
                    chooseAreaCtrl.fullAddressError = false;
                    chooseAreaCtrl.wrongAddressError = true;
                    return;
                }

                chooseAreaCtrl.wrongAddressError = false;
                var queryArea = chooseAreaCtrl.area || chooseAreaCtrl.queryArea;

                if(chooseAreaCtrl.isActiveMobileExpress) {
                    options.isForMobileExpressDelivery = true;
                }
                return SpDeliveryAreasService.filterDeliveryAreas(chooseAreaCtrl.chooseAreaMode,
                    chooseAreaCtrl.area || chooseAreaCtrl.queryArea,
                    ignoreMultipleAddresses,
                    _selectPlaceIdByPlaceDescription(queryArea), options).then(function(resp) {
                    // show wrong address error if there if no area has been found from query parameter
                    if (!resp.areas.length && chooseAreaCtrl.queryArea) {
                        chooseAreaCtrl.area = chooseAreaCtrl.queryArea;
                        chooseAreaCtrl.wrongAddressError = true;
                        return;
                    // show "areaNotFoundLog" if no area has been found
                    } else if(!resp.areas.length) {
                        chooseAreaCtrl.currentSearchMessageMode = searchMessageModes.NO_STORE_FOUND;
                        chooseAreaCtrl.chooseAreaAdvancedCurrentDialog = chooseAreaAdvancedDialogs.NO_STORE_FOUND;
                        changeVisibleState(CHOOSE_AREA_STATES.AREA_NOT_FOUND);
                        return;
                    }

                    var branchDist = {};
                    chooseAreaCtrl.foundScheduledDeliveryAreaByBranch = {}
                    chooseAreaCtrl.foundExpressDeliveryAreaByBranch = {}
                    angular.forEach(resp.areas, function (area) {
                        // add area of a branch by default.
                        if (!branchDist[area.branch.id]) {
                            branchDist[area.branch.id] = area;
                        }

                        // handle for chose-delivery-tab
                        // prefer delivery for the correctness of old flows.
                        if (!chooseAreaCtrl.foundScheduledDeliveryAreaByBranch[area.branch.id] && area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.DELIVERY) {
                            chooseAreaCtrl.foundScheduledDeliveryAreaByBranch[area.branch.id] = area;
                        }

                        if (!chooseAreaCtrl.foundExpressDeliveryAreaByBranch[area.branch.id] && isAreaSupportExpressDelivery(area)) {                            
                            chooseAreaCtrl.foundExpressDeliveryAreaByBranch[area.branch.id] = area;
                        }
                    });
                    
                    resp.areas = Object.keys(branchDist).map(function(key) {
                        return branchDist[key];
                    });
                    resetErrors();
                    changeVisibleState(CHOOSE_AREA_STATES.CHOOSE_AREA);
                    chooseAreaCtrl.isPickupButton = false;
                    chooseAreaCtrl.isOnlyPickupAreas = !resp.areas.find(function(area) {
                        return area.deliveryTypeId !== SP_SERVICES.DELIVERY_TYPES.PICKUP;
                    });
                    if(resp.areas.length === 1) {
                        chooseAreaCtrl.currentSearchMessageMode = searchMessageModes.ONE_STORE_FOUND;
                        chooseAreaCtrl.chooseAreaAdvancedCurrentDialog = chooseAreaAdvancedDialogs.ONE_STORE_FOUND;
                    } else {
                        chooseAreaCtrl.currentSearchMessageMode = searchMessageModes.MULTIPLE_STORE_FOUND;
                        chooseAreaCtrl.chooseAreaAdvancedCurrentDialog = chooseAreaAdvancedDialogs.MULTIPLE_STORE_FOUND;
                    }
                    _setFoundAreas(resp.areas, resp.addressComponents);

                }).catch(function(err) {
                    if (err.statusCode === 400) {
                        chooseAreaCtrl.fullAddressError = false;
                        chooseAreaCtrl.wrongAddressError = true;
                        return;
                    } else if (err.statusCode === 300) {
                        document.querySelector('#area').focus();
                        chooseAreaCtrl.area = '';
                        chooseAreaCtrl.addressChoices = [];
                        angular.forEach(err.data.addresses, function (address) {
                            chooseAreaCtrl.addressChoices.push(address.formatted_address);
                        });
                        return;
                    }

                    throw err;
                });
            }

            function shouldShowExpressDelivery(areaId){
                return chooseAreaCtrl.mobileExpressDeliverySettings && chooseAreaCtrl.mobileExpressDeliverySettings.isActive && chooseAreaCtrl.foundExpressDeliveryAreaByBranch[areaId];
            }
            function isAreaSupportExpressDelivery(area) {
                return (area && area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY && isAreaHasTimeSlot(area) && isAnyAvailableTimeSlotForNow(area) && !isTimeSlotExceededLimit(area)) || false;
            }

            function isAreaHasTimeSlot(area) {
                return area && area.times && area.times.length > 0 || false;
            }

            function isAnyAvailableTimeSlotForNow(area) {
                var now = new Date();
                return area && area.times && area.times.length > 0 && area.times.some(function(timeslot) {
                    return new Date(timeslot.newFrom.split("Z")[0]) <= now && now <= new Date(timeslot.newTo.split("Z")[0]);
                }) || false;
            }

            function isTimeSlotExceededLimit(area) {
                var isTimeSlotExceededLimit = false;
                if (!area || !area.times || !area.times.length) return true;
                
                area.times.forEach(function(timeslot) {
                    if (timeslot.isFull) {
                        isTimeSlotExceededLimit = true;
                    }
                });
                return isTimeSlotExceededLimit;
            }

            function selectArea(area) {
                var setCookiePromise = SpDeliveryAreasService.setRetailerIdCookie(area.retailer.id);
                var setUserArea = null;

                return Promise.all([setCookiePromise, setUserArea]).then(function () {
                    Config.multiRetailers.hasCookie = true;
                    Config.setLocalStorageItem('mobileZuzBranchAreaId', +area.id);

                    return Config.changeBranch(area.branch.id, area.id, {
                        typedArea: area.name,
                        newRetailerId: area.retailer.id
                    });
                }).then(function(isReload) {
                    mDesign.hide();
                    $state.go('app.home');
                    if (area.path.includes('specials')) {
                        $timeout(function() {
                            $state.go('app.specials');
                        }, 200);
                    }
                });
            }

            function _selectPlaceIdByPlaceDescription(description){
                if (chooseAreaCtrl.fullAutoCompleteData){
                    var place = chooseAreaCtrl.fullAutoCompleteData.find(function(place){ return place.description === description });
                    return place && place.place_id;
                }
                return  null;
            }

            function filterAreasInputChange() {
                chooseAreaCtrl.addressDetails = {};
                resetErrors();
            }

            function resetErrors() {
                chooseAreaCtrl.fullAddressError = false;
                chooseAreaCtrl.wrongAddressError = false;
            }

            function showPickupAreas() {
                changeVisibleState(CHOOSE_AREA_STATES.CHOOSE_AREA);
                chooseAreaCtrl.isPickupButton = true;
                chooseAreaCtrl.isOnlyPickupAreas = false;
                _setFoundAreas(chooseAreaCtrl.pickupAreas);
            }

            /**
             * Submit choose area form
             * @public
             *
             * @param {SpDeliveryArea} area
             *
             * @returns {Promise}
             */
            function chooseArea(area) {
                var setCookiePromise = SpDeliveryAreasService.setRetailerIdCookie(area.retailer.id);
                var sessionUserId = User.session && User.session.userId;
                var setUserArea = User.setUserArea(area, sessionUserId);
                var isBranchSupportExpressDelivery = !!(chooseAreaCtrl.foundExpressDeliveryAreaByBranch && chooseAreaCtrl.foundExpressDeliveryAreaByBranch[area.branch.id]) || !!(Config.branch && Config.branch.foundScheduledDeliveryOrPickupArea && Config.branch.foundExpressDeliveryArea);

                return Promise.all([setCookiePromise, setUserArea]).then(function () {
                    Config.multiRetailers.hasCookie = true;

                    if (Config.retailerId !== area.retailer.id) {
                        Util.clearLocalStorage();
                    }
                    if(area.deliveryTypeId && chooseAreaCtrl.isActiveMobileExpress){
                        Config.setLocalStorageItem('mobileZuzModeToggle', area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY ? DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY : DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP);
                        if(area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY){
                            PermanentFilters.addProductTagsFilters([PRODUCT_TAG_ID.EXPRESS_DELIVERY], true);
                        }else{
                            PermanentFilters.addProductTagsFilters([], true);
                        }
                    }
                    Config.setLocalStorageItem('mobileZuzTypedAreaText', chooseAreaCtrl.area);
                    Config.setLocalStorageItem('mobileZuzTypedAreaAddressComponents', JSON.stringify(chooseAreaCtrl.addressComponents));
                    Config.setLocalStorageItem('mobileZuzBranchAreaId', +area.id);
                    Config.setLocalStorageItem('mobileZuzAreaSupportedExpressDelivery', JSON.stringify(isBranchSupportExpressDelivery));
                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_METHOD_CHANGED, {
                        deliveryTypeId: area.deliveryTypeId,
                        selectedStoreId: area.id,
                    });
                    return Config.changeBranch(area.branch.id, area.id, {
                        typedArea: chooseAreaCtrl.area,
                        newRetailerId: area.retailer.id
                    });
                }).then(function(isReload) {
                    // set area to config to use when removalItemPopup is shown after user choose Express Delivery on Advanced Availability Area check popup.
                    if(area && area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.DELIVERY && area.branch.id === Config.branch.id) {
                        setFoundScheduledDeliveryAreaToConfig(area);
                    }

                    if(area && area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY && area.branch.id === Config.branch.id) {
                        setFoundExpressDeliveryAreaToConfig(area);
                    }

                    if (!isReload) {
                        mDesign.hide();
                        if(localStorage.getItem('mobileZuzAutoImportToCartParams')) {
                            $state.go('app.singleOrder', JSON.parse(localStorage.getItem('mobileZuzAutoImportToCartParams')));
                        }
                    } else {
                        $state.go('app.home');
                        Loading.counter(null, 1);
                    }
                });
            }

            function handleExpressDeliverySelection(area) {
                var nonExpressDeliveryLines = Cart.getNonExpressDeliveryLines();
                var overQuantityLines = Cart.getOverQuantityLines(DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY);
                
                if (!_shouldShowRemoveNonExpressCartItemsDialog(area, nonExpressDeliveryLines, overQuantityLines)) {
                    return chooseArea(area).then(_redirectBackToHome);
                }

                _showRemoveInvalidCartItemsPopup(nonExpressDeliveryLines, overQuantityLines).then(function(result) {
                    // user choose remove items and switch to express
                    if (result && result.isConfirmed) {

                        return chooseArea(area).then(_redirectBackToHome);
                    } else {
                        // user choose stay with scheduled delivery -> select scheduled delivery area in the same branch
                        return chooseArea(chooseAreaCtrl.foundScheduledDeliveryAreaByBranch[area.branch.id]).then(_redirectBackToHome);
                    }
                });
            }

            function _redirectBackToHome() {

                // close side nav if it is open
                if ($mdSidenav('sidenav').isOpen()) {
                    $mdSidenav('sidenav').close();
                }
                
                if($state.current.name !== 'app.home') {
                    $state.go('app.home');
                }
            }

            function _showRemoveInvalidCartItemsPopup(nonExpressDeliveryLines, overQuantityLines) {
                return mDesign.dialog({
                    templateUrl: 'views/invalid-cart-items-removal-popup.html',
                    controller: 'InvalidCartItemsRemovalCtrl',
                    controllerAs: 'invalidCartItemsRemovalCtrl',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    locals: {
                        invalidLines: nonExpressDeliveryLines || [],
                        isShowLimitWarningMessage: false,
                        overQuantityLines: overQuantityLines || []
                    }
                })
            }

            function _shouldShowRemoveNonExpressCartItemsDialog(area, nonExpressDeliveryLines, overQuantityLines) {
                return area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY && (nonExpressDeliveryLines.length > 0 || overQuantityLines.length > 0);
            }

            function setFoundScheduledDeliveryAreaToConfig(area) {
                Config.branch.foundScheduledDeliveryOrPickupArea = area;
            }

            function setFoundExpressDeliveryAreaToConfig(area) {
                Config.branch.foundExpressDeliveryArea = area;
            }

            function filterFoundAreas(area) {
                return SpDeliveryAreasService.isAreaMatchTerm(area, chooseAreaCtrl.chooseAreaQuery);
            }

            function areaNotFoundLog() {
                // TODO: validation?
                return SpDeliveryAreasService.addAreaNotFoundLog(chooseAreaCtrl.area, chooseAreaCtrl.userEmail).then(function () {
                    cancel();
                });
            }

            /**
             * Set found areas
             * @private
             *
             * @param {Array<Object>} areas
             * @param {Array<Object>} [addressComponents]
             */
            function _setFoundAreas(areas, addressComponents) {
                chooseAreaCtrl.foundAreas = areas;
                chooseAreaCtrl.addressComponents = addressComponents;

                chooseAreaCtrl.areasDeliveryTimeTypes = {};
                SpDeliveryAreasService.getAreasDeliveryTimeTypes(chooseAreaCtrl.foundAreas).then(function(map) {
                    chooseAreaCtrl.areasDeliveryTimeTypes = map;
                    _setDeliveryWithinDaysTag();
                });

            }

            function _setDeliveryWithinDaysTag() {
                if (chooseAreaCtrl.deliveryWithinDaysTag) {
                    return;
                }

                var hasWithinDaysWarning = chooseAreaCtrl.foundAreas.find(function(area) {
                    return _isAreaDeliveryWithinDaysOnly(area);
                });
                if (!hasWithinDaysWarning) {
                    return;
                }

                return SpProductTags.getDeliveryWithinDaysTag().then(function(tag) {
                    chooseAreaCtrl.deliveryWithinDaysTag = tag;
                });
            }

            function isShowDeliveryWithinDaysWarning(area) {
                if (!chooseAreaCtrl.deliveryWithinDaysTag) {
                    return;
                }

                return _isAreaDeliveryWithinDaysOnly(area);
            }

            function _isAreaDeliveryWithinDaysOnly(area) {
                var mapValue = chooseAreaCtrl.areasDeliveryTimeTypes[area.id];
                if (!mapValue) {
                    return false;
                }

                return mapValue.length === 1 && mapValue[0] === DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS;
            }

            function isBranchNameHidden() {
                if(Config.retailer.settings.isHiddenBranchName === 'true' && chooseAreaCtrl.foundAreas[0].deliveryTypeId !== SP_SERVICES.DELIVERY_TYPES.PICKUP) {
                    return true;
                }

                return false;
            }

            function cancel() {
                mDesign.hide();
            }

            function changeVisibleState(toState) {
                chooseAreaCtrl.visibleState = toState;
                $timeout(function () {
                    $dialogElement = $dialogElement || document.querySelector('body > .md-dialog-container > md-dialog.choose-area-dialog');
                    $dialogElement && $dialogElement.focus()
                });
            }

            function getScheduledDeliveryButtonText(branchId, isMultipleStore) {
                if (chooseAreaCtrl.currentAdvancedAreaAvailabilitySettings &&
                    chooseAreaCtrl.currentAdvancedAreaAvailabilitySettings.scheduledDeliveryButtonText) {
                    return chooseAreaCtrl.currentAdvancedAreaAvailabilitySettings.scheduledDeliveryButtonText;
                }

                var hasExpressDelivery = shouldShowExpressDelivery(branchId);
                if(hasExpressDelivery) {
                    return 'default_scheduled_btn_text';
                }

                return isMultipleStore ? 'Choose' : 'default_one_store_popup_continue_button_text';
            }
        }]);
})(angular, angular.module('mobilezuz'));
